module.exports = __webpack_public_path__ + "static/img/6299_phase_function_Paper_Points.f675020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6299_phase_function_Paper_Points.png
// module id = dU4V
// module chunks = 0